module.exports = __webpack_public_path__ + "img/floor_nl.3b38e903.png";